/**
 * Runtime feature-availability layer.
 *
 * During the billing-rebuild prod cutover the old (`1.20.x`) and new
 * release run simultaneously behind one gateway, so a brand-new feature's
 * API can 404 (route absent on the old replicas) or report itself
 * disabled. Rather than hard-error or hide these surfaces, the UI probes
 * each feature's own endpoint at runtime and renders the surface as
 * visible-but-disabled until the API answers — then enables it
 * automatically. No backend change is required.
 */
export type FeatureId =
  | 'ai-usage'
  | 'ai-agent'
  | 'analytics-destinations'
  | 'delivery-analytics'
  | 'ai-schedules'
  | 'migration';

/**
 * - `available`   — the API responded (2xx, or 403 = exists-but-no-perms).
 * - `unavailable` — the API 404'd or reported the feature disabled (503 /
 *   `scheduling_disabled`).
 * - `unknown`     — not probed yet, or a transient failure (network / 5xx)
 *   we don't want to treat as a hard "off".
 */
export type FeatureStatus = 'available' | 'unavailable' | 'unknown';

export const FEATURE_IDS: FeatureId[] = [
  'ai-usage',
  'ai-agent',
  'analytics-destinations',
  'delivery-analytics',
  'ai-schedules',
  'migration',
];
